var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{staticClass:"lista-menu",on:{"click":function($event){$event.stopPropagation();return _vm.abrirModal()}}},[_c('span',[_vm._v("Informações TCU - BOLSISTAS")]),_c('filtro',{ref:"filtroModal",on:{"filtrar":function($event){return _vm.obterRelatorio($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }